import { CurrencyPipe } from '@angular/common';
import { Column, GridRow } from '@shared';

export class SubstitutionAnchor {
  @Column({
    field: 'itemName',
    title: 'Anchor',
    order: 1,
    type: 'string',
    width: 120,
    sortable: true,
    filterType: 'text',
    align: 'left',
  })
  itemName: string = '';


  @Column({
    field: 'price',
    title: 'Anchor Price',
    order: 3,
    pipeToken: CurrencyPipe,
    type: 'number',
    width: 120,
    sortable: true,
    filterType: 'numeric',
    align: 'center',
  })
  price: number | null = null;

  @Column({
    field: 'priceDelivery',
    title: 'Anchor Delivery Price',
    order: 4,
    pipeToken: CurrencyPipe,
    type: 'number',
    width: 120,
    sortable: true,
    filterType: 'numeric',
    align: 'center',
  })
  priceDelivery: number | null = null;

  parId: number = 0;

  constructor(substitutionAnchor?: Partial<SubstitutionAnchor>) {
    this.itemName = substitutionAnchor?.itemName || '';
    this.price = substitutionAnchor?.price || null;
    this.priceDelivery = substitutionAnchor?.priceDelivery || null;
    this.parId = substitutionAnchor?.parId || 0;
  }
}

export class GridRowSubstitutionAnchor extends GridRow(SubstitutionAnchor) {}

